import React from "react";
import {Link} from "../../../../../../../router";
import {apiReloginMerchant} from "../../../../../../../api/_auth";
import {
  ACCOUNT_SETTINGS_PROFILE,
  LINK_REFERRAL_DASHBOARD,
} from "../../../../../../../constants/links";

import Ripple from "../../../../../../dumb/Ripple";
import LogoutBtn from '../../../../helpers/LogoutBtn';

export default (account) => {
  const accountsList = account.accountsList || [];

  const accLogoutBtn = <LogoutBtn />;
  const referralPanelLink = <Link href={LINK_REFERRAL_DASHBOARD} data-testid="refPanelLink">Referral Panel</Link>;

  const accSettingsLink = <Link href={ACCOUNT_SETTINGS_PROFILE} data-testid="accSettingsLink">Account Settings</Link>;
  const divider = {divider: true};

  const dropdownItems = [accSettingsLink, divider];

  if (account.is_referral) {
    dropdownItems.push(referralPanelLink);
    dropdownItems.push(divider);
  }

  if (accountsList.length) {
    accountsList.forEach((acc, i) => {
      dropdownItems.push(
        <Ripple
          key={i}
          onClick={() => apiReloginMerchant({id: acc.id})}
          data-testid={`reloginMerchant_${acc.id}`}
        >
          {acc.name || acc.login}
        </Ripple>
      )
    })
    dropdownItems.push(divider);
  }

  return (
    [
      ...dropdownItems,
      accLogoutBtn
    ]
  );
}
